import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'bom-link',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss'],
})
export class LinkComponent implements OnInit {
  @Input()
  cssClass?: string;
  @Input()
  target: '_blank' | '_self' | '_parent' | '_top' = '_blank';
  @Input()
  url: string;
  @Input()
  text?: string;
  @Input()
  showIcon: boolean;

  constructor() {}

  ngOnInit() {}
}
